import { useRef} from 'react'
import {useIntl} from 'react-intl'
import useHandleCloseModal from '../../../hooks/HandleCloseModal'
import {useFormik} from 'formik'

import {KTSVG} from '../../../_metronic/helpers'
import {ITemplateAnalytic} from '../../../interfaces/Analytics/Analytics'
import { truncateText } from '../../../functions/general'


interface IProps {
  template: ITemplateAnalytic
}
export default function DetailTemplate({template}: IProps) {
  const modalRef = useRef<HTMLDivElement | null>(null)
  const closeModalRef = useRef<HTMLButtonElement>(null)

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
    },
  

    onSubmit: async (values, {setStatus, setSubmitting}) => {
    return
    },
  })


  const {handleCloseModal} = useHandleCloseModal(modalRef, closeModalRef, formik)


  return (
    <>
      <div
        className={`modal fade`}
        tabIndex={-1}
        id={`detail-template-modal-${template.id}`}
       
      >
        <div className='modal-dialog modal-dialog-centered' >
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>
               {/*  {intl.formatMessage({id: 'FORM.ACTION.DETAIL'})}  */}
               {truncateText(template.name,25) }
              </h5>
              <button
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                 data-bs-dismiss='modal'
                aria-label='Close'
                
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </button>
            </div>

              <div className='modal-body'>
                {template.description}
              </div>
          </div>
        </div>
      </div>
    </>
  )
}
